/**
 * Resets homepage header + SearchTap UI after closing search on the index page.
 * Keeps the transparent header and hides the inline mobile search bar without
 * breaking SearchTap autocomplete on repeat opens.
 */
(() => {
    const TRANSPARENT_HEADER_THRESHOLD = 25;
    const CLOSE_SEARCH_SELECTORS =
      '.st-back, .st-search-close-icon, .input-close-btn-mobile, .input-close-btn, .st-autocomplete-cross-icon, .close_search';
    const OPEN_SEARCH_SELECTORS =
      '#search-desktop-icon, span.st-mobile-searchicon, div#search-mobile.st-search-bar, #search-hamburger-mobile';
  
    const isHomepagePath = () => {
      const path = window.location.pathname.replace(/\/$/, '') || '/';
      return path === '/' || path === '';
    };
  
    const shouldResetHomepageHeader = () => {
      if (!isHomepagePath()) return false;
      if (window.location.pathname.includes('/search')) return false;
      return !new URLSearchParams(window.location.search).has('q');
    };
  
    const recalculateHeaderHeight = () => {
      const headerElement = document.querySelector('.shopify-section--header');
      const headerWrapper = headerElement?.querySelector('.header__wrapper');
      if (!headerElement || !headerWrapper) return;
  
      document.documentElement.style.setProperty('--header-height', `${headerElement.clientHeight}px`);
      document.documentElement.style.setProperty(
        '--header-height-without-bottom-nav',
        `${headerWrapper.clientHeight}px`
      );
    };
  
    const syncTransparentHeader = () => {
      const storeHeader = document.querySelector('store-header[transparent]');
      if (!storeHeader) return;
  
      if (window.scrollY <= TRANSPARENT_HEADER_THRESHOLD) {
        storeHeader.classList.add('header--transparent');
      } else {
        storeHeader.classList.remove('header--transparent');
      }
    };
  
    const unlockPageScroll = () => {
      document.body.classList.remove(
        'searchtap',
        'searchtap-search',
        'searchtap-collection',
        'st-no-scroll',
        'st-hide-apps'
      );
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('left');
      document.body.style.removeProperty('width');
      document.body.style.removeProperty('height');
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('overflow');
    };
  
    const clearSearchUiOverrides = () => {
      document.querySelector('.st-autocomplete-box-container')?.style.removeProperty('display');
      document.querySelector('.st-autocomplete-content')?.style.removeProperty('display');
      document.querySelector('.st-trending-box')?.style.removeProperty('display');
  
      const desktopSearchContainer = document.querySelector('.st-search-autocomplete-desktop.site-nav__link');
      if (desktopSearchContainer) {
        desktopSearchContainer.style.removeProperty('display');
      }
    };
  
    const restoreHomepageHeader = () => {
      if (!shouldResetHomepageHeader()) return;
  
      unlockPageScroll();
  
      document
        .querySelectorAll('div#search-mobile.st-search-bar, div#search-hamburger-mobile.st-search-bar')
        .forEach((searchBar) => {
          searchBar.style.setProperty('display', 'none', 'important');
        });
  
      document.querySelectorAll('span#search-mobile.st-mobile-searchicon').forEach((searchIcon) => {
        searchIcon.style.removeProperty('display');
      });
  
      syncTransparentHeader();
  
      const homeHeader = document.querySelector('header .home-header');
      if (homeHeader) {
        homeHeader.classList.remove('bg-black-header');
      }
  
      recalculateHeaderHeight();
    };
  
    const restoreHomepageHeaderBurst = () => {
      [0, 50, 150, 300, 600].forEach((delay) => {
        setTimeout(restoreHomepageHeader, delay);
      });
    };
  
    if (!document.body.dataset.homepageHeaderObserver) {
      new MutationObserver((mutations) => {
        const searchClosed = mutations.some((mutation) => {
          const previous = mutation.oldValue || '';
          const current = document.body.className;
          const hadLock = previous.includes('st-no-scroll') || previous.includes('searchtap-search');
          const hasLock = current.includes('st-no-scroll') || current.includes('searchtap-search');
          return hadLock && !hasLock;
        });
  
        if (searchClosed) {
          restoreHomepageHeaderBurst();
        }
      }).observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true
      });
      document.body.dataset.homepageHeaderObserver = 'true';
    }
  
    document.addEventListener('click', (event) => {
      if (event.target.closest(OPEN_SEARCH_SELECTORS)) {
        clearSearchUiOverrides();
        return;
      }
  
      if (event.target.closest(CLOSE_SEARCH_SELECTORS)) {
        restoreHomepageHeaderBurst();
      }
    });
  
    window.addEventListener('popstate', restoreHomepageHeaderBurst);
  
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        restoreHomepageHeaderBurst();
      }
    });
  })();